import { useNavigate } from "react-router-dom";
import { BackNav } from "@/components/BackNav";
import { CenteredError } from "@/components/Spinner";
import { LockedSectionPopup } from "@/components/LockedSectionPopup";
import { useMySubscription } from "@/api/hooks";
import { ApiError } from "@/api/client";
import { isActiveSubscription } from "@/api/types";

/** Текст помилки для людини: деталь від сервера без «API 403:», мережа — своїми словами. */
export function errorText(error: unknown, fallback = "Не вдалося завантажити. Спробуй ще раз."): string {
  return error instanceof ApiError && error.status !== 0 && error.detail ? error.detail : fallback;
}

/**
 * Помилка завантаження платного розділу (owner 2026-10-25, знайшла система тестування).
 *
 * Безкоштовний чи тестовий користувач, що відкрив Базу знань, Курс, Подкасти чи Збережені ПРЯМИМ
 * посиланням (кнопка розсилки, закладка), бачив сирий текст «API 403: Доступ до цього розділу…».
 * За правилом «для безкоштовних не ховаємо — сіре й під замком» тут має бути той самий попап розділу,
 * що й по кліку з Головної. Закрив попап — повертаємось назад (або на Головну, якщо назад нікуди).
 * Будь-яка інша помилка — звичайний текст без технічного префікса.
 */
export function PageLoadError({
  error,
  section,
  fallback = "Не вдалося завантажити. Спробуй ще раз.",
}: {
  error: unknown;
  section: "knowledge_base" | "course" | "saved";
  fallback?: string;
}) {
  const navigate = useNavigate();
  const sub = useMySubscription();
  const locked = error instanceof ApiError && error.status === 403;
  if (!locked) {
    return <CenteredError message={errorText(error, fallback)} />;
  }
  const active = sub.data && isActiveSubscription(sub.data) ? sub.data : null;
  const close = () => (window.history.length > 1 ? navigate(-1) : navigate("/", { replace: true }));
  return (
    <>
      <BackNav />
      <LockedSectionPopup sectionKey={section} open onClose={close} isTest={active?.plan === "test"} />
    </>
  );
}
